/**
 * @author wuTao
 * @description 班级学员查看信息
 * @Date 2020/3/9
 */
import React from 'react';
import {connect} from 'dva';
import {component_tool, framework_tool, utils_tool} from '@/tool'
import {Col, Card, Row, Spin} from 'antd'
import '@/styles/containers/face/class/style.less';

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizMenu, WizDropdown, WizDataTable, WizTimeline, WizTag, WizIcon, WizButton, WizDivider, WizEmpty, WizAvatar, WizList, WizDescriptions, WizRow, WizCol} = component_tool;
let {Session} = utils_tool;
const { Meta } = Card;
const {CheckableTag} = WizTag;
const {Oper} = WizDataTable;


class ClassStudentDetail extends WizContainer {

  componentName = 'ClassStudentDetail';

  constructor(props) {
    super(props);
    this.state = {
      classId: null,
      entityRecord: null,
    };
    this.initialValue = {};
    this.aideTypeList = [];
    this.getAideTypeList();
  }

  _componentWillMount() {
    const {history} = this.props;
    if (history.location && history.location.pathname === '/face/classList/classStudentDetail') {
      if (history.location.record) {
        Session.set('classInfoRecord', history.location.record);
        this.initialValue = history.location.record;
        this.setState({classId: this.initialValue.id})
      } else if (Session.get('classInfoRecord')) {
        this.initialValue = Session.get('classInfoRecord') ? Session.get('classInfoRecord') : {};
        this.setState({classId: this.initialValue.id})
      }
      //加载有效班级环节 / 及班级学员详细信息 / 及班级学员成绩评语信息 / 及班级学员问卷评价信息 / 及课堂环节参与情况
      this.getClassAideList();
      this.getClassStudentPersonInfo();
      this.getClassStudentJoinAllProcessInfo();
    }
  }

  propsAndStateOnChange = {
    classAideList: this._getClassAideListOver.bind(this),
    personAndUserIdentitiesInfo:this._getPersonAndUserIdentitiesInfoOver.bind(this),
    classStudentJoinAllProcessInfo:this,
    aideTypeList: this._getAideTypeListOver.bind(this),
  };


  _getClassAideListOver(nextProps, nextState) {
    if (nextProps.classAideList.code == 1) {
      this.initialValue.classAideList = nextProps.classAideList.data
    }
    return true;
  }

  _getPersonAndUserIdentitiesInfoOver(nextProps, nextState){
    if (nextProps.personAndUserIdentitiesInfo.code == 1) {
      this.initialValue.personAndUserIdentitiesInfo = nextProps.personAndUserIdentitiesInfo.data
    }
  }

  _getClassStudentJoinAllProcessInfoOver(nextProps, nextState){
    if (nextProps.classStudentJoinAllProcessInfo.code == 1) {
      this.initialValue.classStudentJoinAllProcessInfo = nextProps.classStudentJoinAllProcessInfo.data
    }
  }

  _getAideTypeListOver(nextProps, nextState) {
    if (nextProps.aideTypeList.code == 1) {
      this.aideTypeList = nextProps.aideTypeList.data;
    }
    return true;
  }


  /**获取对应的助手流程数据 */
  getClassAideList() {
    this.doAction({
      path: 'classAideManagement/list',
      payload: {
        key: 'classAideList',
        apiParams: {
          classId: 2,
          status:0,
          isOrderNum: true
        }
      }
    });
  }

  /**获取对应的学员信息数据 */
  getClassStudentPersonInfo() {
    this.doAction({
      path: 'personManage/getPersonAndUserIdentitiesInfo',
      payload: {
        key: 'personAndUserIdentitiesInfo',
        apiParams: {
          personId: this.initialValue.personId,
        }
      }
    });
  }

  /**获取对应的学员所参与的所有环境信息数据 */
  getClassStudentJoinAllProcessInfo() {
    this.doAction({
      path: 'classStudentManagement/getClassStudentJoinAllProcessInfo',
      payload: {
        key: 'classStudentJoinAllProcessInfo',
        apiParams: {
          personId: this.initialValue.personId,
          classInfoId: this.initialValue.classInfoId,
        }
      }
    });
  }

  /**获取助手类型 */
  getAideTypeList() {
    this.doAction({
      path: 'aideTypeManagement/list',
      payload: {
        key: 'aideTypeList',
        apiParams: {
          status: 0,
        }
      }
    });
  }

  /**保存方法 */
  submitLive(values) {
    const {history} = this.props;
    let apiPath = "live/add";
    if (history.location && history.location.pathname === '/face/classList/classAideDetail') {
      apiPath = "live/update";
    }
    this.doAction({
      path: apiPath,
      payload: {
        key: 'saveLive',
        apiParams: {
          id: this.state.liveId,
          ...values,
        }
      }
    });
  }

  handleAideTypeTag = (checked, aideType) => {

  };

  _aideType() {
    let aideTypeList = this.aideTypeList;
    aideTypeList.map((aideType) => {
      return (
        <WizTag key={aideType.id}>{aideType.name}</WizTag>
      )
    })
  }

  /**
   * 加载助手流程
   */
  _classAideCard(classAide) {
    const {id, classId, className, aideTypeId, aideTypeName, entityId, status} = classAide;
    let isClose = '';
    if (status && status != 0) {
      isClose = '  已关闭'
    }
    let titleStr = aideTypeName ? aideTypeName + isClose : "";
    return (
      <WizCard title={this._classAideCardTitle(classAide)} icon='0' size={'small'} style={{marginLeft: 2, height: 100}}
               headStyle={{
                 height: '33%',
                 fontSize: 14,
                 color: 'rgba(0, 0, 0, 0.85)',
                 fontWeight: 500,
                 background: '#FFFFFF',
                 borderBottom: 0
               }}
               bodyStyle={{textAlign: 'center', verticalAlign: 'middle', padding: 0, margin: 0, height: '67%'}}
               extra={this._classAideCardButtonStyle(classAide)}
      >
        {this._classAideRow(classAide)}
      </WizCard>
    );
  }

  /**
   * 加载助手流程模块抬头
   */
  _classAideCardTitle(classAide) {
    const {id, classId, className, aideTypeId, aideTypeName, entityId, status} = classAide;
    let isClose = '';
    if (status && status != 0) {
      isClose = '  已关闭'
    }
    return [
      aideTypeName, isClose
    ]
  }

  /**
   * 加载流程快内容
   */
  _classAideRow(classAide) {
    return [
      <Row className="row-style">
        <Col span={8} className="col-style"><span className="span-style">开始时间：</span><span></span></Col>
        <Col span={15} className="col-style"><span className="span-style">预计时长：</span><span></span></Col>
      </Row>,
      <Row className="row-style">
        <Col span={23} className="col-style">{'111'}</Col>
      </Row>
    ]
  }

  _createMenu(children, classAide) {
    const {id} = classAide;
    return (
      <WizMenu style={{textAlign: 'center'}}>
        {children.map((val, index) => (
          <WizMenu.Item key={val.key || index}>{val}</WizMenu.Item>
        ))}
      </WizMenu>
    );
  };

  _classAideCardButtonStyle(classAide) {
    let children = this._classAideCardButton(classAide);
    let relMaxNum = 5;
    return (
      <div className="components-dropdown-demo-dropdown-button" onClick={e => e.stopPropagation()}>
        {children.length > relMaxNum ? (
          <>
            <Row>
              <Col span={18}>
                {children.slice(0, relMaxNum)}
              </Col>
              <Col span={5}>
                <div style={{height: '100%', padding: 0, marginLeft: '-80%'}}>
                  <WizDropdown.Button type="link"
                                      placement="bottomRight"
                                      overlay={this._createMenu(children.slice(relMaxNum, children.length), classAide)}
                  />
                </div>
              </Col>
            </Row>
          </>
        ) : (
          children
        )}
      </div>
    )
  }

  _buttonOperation(classAide) {

  }

  /**
   * 按钮组
   */
  _classAideCardButton(classAide) {
    const {id, classId, aideTypeId} = classAide;
    return [
      <WizButton key={id + "_look_" + aideTypeId} type="link" size="small"
                 onClick={e => this._buttonOperation(classAide)}>查看</WizButton>,
      <WizDivider type="vertical" style={{padding: 0, margin: 0}}/>,
      <WizButton key={id + "_edit" + aideTypeId} type="link" size="small"
                 onClick={e => this._buttonOperation(classAide)}>编辑</WizButton>,
      <WizDivider type="vertical" style={{padding: 0, margin: 0}}/>,
      <WizButton key={id + "_close" + aideTypeId} type="link" size="small" style={{paddingRight: '-15'}}
                 onClick={e => this._buttonOperation(classAide)}>关闭</WizButton>,
      <WizButton key={id + "_enable" + aideTypeId} size="small"
                 onClick={e => this._buttonOperation(classAide)}>启用</WizButton>,
      <WizButton key={id + "_del" + aideTypeId} size="small"
                 onClick={e => this._buttonOperation(classAide)}>删除</WizButton>,
      <WizButton key={id + "_export" + aideTypeId} size="small"
                 onClick={e => this._buttonOperation(classAide)}>导出问卷情况</WizButton>,
    ]
  }

  _render() {
    const {classAideManagementLoading, aideTypeManagementLoading} = this.props;
    let initialValue = this.initialValue;
    let aideTypeList = this.aideTypeList;
    const {personAndUserIdentitiesInfo,classStudentJoinAllProcessInfo,classAideList} = initialValue;
    let className = "银级认证机电技师A班";
    let classDate = "2020-02-27 09:00  ~2020-02-29 17:00";
    let classAideCount = classAideList ? classAideList.length : 0;
    let aideTypeCount = aideTypeList ? aideTypeList.length : 0;
    let isPending = aideTypeCount <= classAideCount ? true : false;
    const aideTypeNode = () =>
      <div>
        <Row>
          <Col span={1}>班级：</Col>
          <Col span={8}>{className}</Col>
          <Col span={1}>时间：</Col>
          <Col span={12}>{classDate}</Col>
        </Row>
      </div>;
    const classAideTitle = () =>
      <div>
        <WizIcon type="schedule"/>
        <span style={{marginLeft: 20}}>课堂环节参与情况</span>
        <span style={{marginLeft: 20}}>({"9/10"})</span>
      </div>
    ;
    return (
      <WizCard title={'学员情况查看'} className="class-aide-detail">
        <Spin tip={'加载中'} spinning={classAideManagementLoading || aideTypeManagementLoading}>
          <WizCard icon='0' type="inner" headStyle={{fontSize: 14, color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500,}}
                   title={aideTypeNode()}>
            <div>

              <CheckableTag key={2} checked={false} onChange={(checked) => {
                this.handleAideTypeTag(checked, 1)
              }}>
                <WizCard bordered={true} hoverable size={'small'}
                         bodyStyle={{textAlign: 'center', verticalAlign: 'middle', padding: 0,}}
                         key={1} style={{width: 300,height:135}}
                >
                  <ul className="ant-card-actions"
                      style={{textAlign: 'center', verticalAlign: 'middle', border: 0, background: '#FFFFFF'}}>
                    <li>
                      <WizAvatar icon="user" style={{
                        backgroundColor: (null),
                        marginLeft: '30%'
                      }}/>{"测试"}
                    </li>
                  </ul>
                </WizCard>
              </CheckableTag>
              <CheckableTag key={3} checked={false} onChange={(checked) => {
                this.handleAideTypeTag(checked, 1)
              }}>
                <WizCard bordered={true} hoverable size={'small'}
                         bodyStyle={{ padding: 0,}}
                         key={1} style={{width: 750,height:135}}
                >
                  <WizCard title={'班级成绩'} icon='0' size='small'
                           headStyle={{color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500, background: '#FFFFFF', borderBottom: 0}}
                           bodyStyle={{textAlign: 'center', verticalAlign: 'middle', padding: 0, margin: 0,}}
                           style={{width:'32%',height:'100%',float:"left"}}>
                    <p style={{wordBreak: "normal",whiteSpace: "pre-wrap",wordWrap: "break-word"}}>{"这是班级成绩的描述，需要自定义渲染"}</p>
                  <br/>
                  <a>{'查看评语'}</a>
                  </WizCard>
                  <WizDivider className="divider-style" type="vertical"/>
                  <WizCard title={'班级评价'} icon='0' size='small'
                           headStyle={{color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500, background: '#FFFFFF', borderBottom: 0}}
                           bodyStyle={{textAlign: 'center', verticalAlign: 'middle', padding: 0, margin: 0,}}
                           style={{width:'32%',height:'100%',float:"left"}}>
                    <p style={{wordBreak: "normal",whiteSpace: "pre-wrap",wordWrap: "break-word"}}>{"这是班级评价的描述，需要自定义渲染"}</p>
                    <br/>
                    <a>{'查看问卷'}</a>
                  </WizCard>
                  <WizDivider className="divider-style" type="vertical"/>
                  <WizCard title={'课堂环节参与情况'} icon='0' size='small'
                           headStyle={{color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500, background: '#FFFFFF', borderBottom: 0}}
                           bodyStyle={{textAlign: 'center', verticalAlign: 'middle', padding: 0, margin: 0,}}
                           style={{width:'32%',height:'100%',float:"left"}}>
                    <p style={{wordBreak: "normal",whiteSpace: "pre-wrap",wordWrap: "break-word"}}>{"这是课堂环节参与情况的描述，需要自定义渲染"}</p>
                  </WizCard>
                </WizCard>
              </CheckableTag>
            </div>
          </WizCard>
          <WizCard icon='0' type="inner" headStyle={{fontSize: 14, color: 'rgba(0, 0, 0, 0.85)', fontWeight: 500,}}
                   title={classAideTitle()}>
            <div>
              {
                classAideCount <= 0 ? <WizEmpty image={WizEmpty.PRESENTED_IMAGE_SIMPLE}/> :
                  <WizTimeline>
                    {
                      classAideList.map((classAide) => {
                        const {id, aideTypeName, orderNum, status} = classAide;
                        return (
                          <WizTimeline.Item key={id}
                                            dot={<WizAvatar size="small"
                                                            style={{
                                                              color: '#FFFFFF',
                                                              backgroundColor: '#4A90E2',
                                                              textAlign: 'center',
                                                              verticalAlign: 'middle',
                                                            }}>
                                              {orderNum}
                                            </WizAvatar>} color="blue">
                            <WizCard bordered={true} bodyStyle={{height: 100, padding: 0}} style={{marginLeft: 30}}>
                              <div>
                                <div style={{
                                  width: '10%', height: 100, float: 'left', position: 'relative',
                                  textAlign: 'center', verticalAlign: 'center'
                                }}>
                                  <p className="center-vertical center-horizontal center-margin">
                                    {
                                      (status === 0) ? <a>{"[" + aideTypeName + "]"}</a> : "[" + aideTypeName + "]"
                                    }
                                  </p>
                                </div>
                                <div style={{width: '90%', height: 100, float: 'left'}}>
                                  <WizDivider className="divider-style" type="vertical"/>
                                  {this._classAideCard(classAide)}
                                </div>
                              </div>
                            </WizCard>
                          </WizTimeline.Item>
                        )
                      })
                    }
                  </WizTimeline>
              }
            </div>
          </WizCard>

          {/*<LiveBroadcastForm submitLive={this.submitLive.bind(this)} initialValue={this.initialValue}/>*/}
        </Spin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const {classAideManagement, aideTypeManagement,personManage,classStudentManagement} = state;
  const classAideList = modelUtils.getModelEntity(classAideManagement, "classAideList");
  const personAndUserIdentitiesInfo = modelUtils.getModelEntity(personManage,"personAndUserIdentitiesInfo");
  const classStudentJoinAllProcessInfo = modelUtils.getModelEntity(classStudentManagement,"classStudentJoinAllProcessInfo");
  const aideTypeList = modelUtils.getModelEntity(aideTypeManagement, "aideTypeList");
  const load = modelUtils.getLoadingState(state, ['classAideManagement', 'personManage','aideTypeManagement','classStudentManagement']);
  return {
    classAideList: classAideList,
    personAndUserIdentitiesInfo:personAndUserIdentitiesInfo,
    classStudentJoinAllProcessInfo:classStudentJoinAllProcessInfo,
    aideTypeList: aideTypeList,
    ...load
  }
};

export default connect(mapStateToProps)(ClassStudentDetail);
